import { helpers } 		from './theme/helpers.js';
import { hamburger } 	from './theme/components/hamburger.js';
import { modal } 		from './theme/components/modal.js';
import { sliders } 		from './theme/components/sliders.js';

import { woo } 			from './theme/components/woo.js';

import { tabs } 		from './theme/components/tabs.js';
import { gallery } 		from './theme/components/gallery.js';

import { animateBlocks } from './theme/components/animate-blocks.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
	},
	
	init: function () {
		var self = this;

		// Global
		self.smoothScroll.init();
		self.onloadClass();
		self.touch();

		// Small things
		self.customFancy();
		self.offsetHeader();
		self.listStyleImage();
		self.autoSizeTextarea();
		self.paraxify();
		self.openSearch();
		self.closeSearch();
		self.tippy();
		self.inlineYoutube();
		self.lazyVideo();
		self.formsReplace();

		// Global
		modal.init();
		hamburger.init();
		sliders.init();
		woo.init();
		tabs.init();
		gallery.init();
		animateBlocks.init();

		jQuery(document).on( 'click', '.scroll-top-button' , function(e) {
			e.preventDefault(); 
			jQuery('html, body').animate({ scrollTop:0 }, 500, 'swing' );
		});
	},

	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},

	listStyleImage: function() {
		jQuery( 'ul[class*="ul-"]' ).each( function(){
			// var icon = jQuery( this ).data( 'list-image' );
			var line_height = jQuery( this ).find( 'li' ).first().css( 'line-height' );

			
			// jQuery( this ).css( '--list-image', icon );
			jQuery( this ).css( '--line-height', line_height );
		});
	},

	formsReplace: function() {
		if( jQuery( '.wpdev-form-control-wrap' ).length ) {
			jQuery( '.wpdev-form-control-wrap input[type="text"]' ).each( function() {
				var input 			= jQuery( this );
				var inputName 		= input.attr( 'name' );
				
				if( inputName.includes( 'name' ) ) {
					input.attr( 'autocomplete', 'name' );
					return;
				}

				if( inputName.includes( 'email' ) ) {
					input.attr( 'autocomplete', 'email' );
					return;
				}

				if( inputName.includes( 'phone' ) ) {
					input.attr( 'autocomplete', 'tel' );
					return;
				}
			});
		}
		
	},

	customFancy: function() {
		jQuery( '.possible-text-content .gallery' ).each(function(){
			let gallID = Math.random().toString(16).slice(2);

			jQuery( this ).find( 'a' ).each(function(){
				jQuery( this ).attr( 'data-fancybox', `gallery-${gallID}` );
			});
		});
		
		// , .possible-text-content a[src*=".png"] > img, .possible-text-content a[src*=".jpeg"] > img, .possible-text-content a[src*=".webp"] > img, .possible-text-content a[src*=".tif"f]  > img, .possible-text-content a[src*=".bmp"] > img
		jQuery( '.possible-text-content a[href*=".jpg"] > img, .possible-text-content a[href*=".png"] > img, .possible-text-content a[href*=".jpeg"] > img, .possible-text-content a[href*=".bmp"] > img, .possible-text-content a[href*=".tiff"] > img, .possible-text-content a[href*=".webp"] > img' ).each(function(){
			let gallID = Math.random().toString(16).slice(2);

			jQuery( this ).parent().attr( 'data-fancybox', gallID );
		});
	},

	offsetHeader: function () {
		if( jQuery( 'body' ).hasClass( 'hide-header-footer' ) ) {
			return false;
		}

		var headerHeight 	= parseInt( jQuery( '.header' ).outerHeight() );
		var offset 			= headerHeight;

		jQuery( 'body' ).css('--header-height', offset + 'px' );

		if( jQuery( '.header' ).hasClass( 'header--overlay') ) {
			jQuery( '.content > section' ).removeAttr('style');
			
			jQuery( '.content > section' ).first().css('--header-overlay-offset', offset + 'px' );
			//jQuery( '.content > section' ).first().css('min-height', firstBlockMinHeight + 'px' );
		} else {
		// TODO-HONZA (prověřit)	jQuery( '.content > section' ).first().css('--header-overlay-offset', 0 );
			jQuery( '.content' ).css('padding-top', offset + 'px' );
		}
	},

	paraxify: function () {
		var myParaxify = paraxify('.paraxify', {
			speed: 1,
			boost: 1,
		});

		if( jQuery( '.paraxify' ).length ) {
			setTimeout(function () {
				jQuery(window).scroll();
			}, 100);
		}
	},

	tippy: function () {
		tippy('[data-tippy-content]', {
			allowHTML: true,
			interactive: true,
		});
	
	},

	autoSizeTextarea: function () {
		jQuery('body').delegate( 'textarea', 'change paste keyup keydown', function (){
			jQuery(this).css( 'height', 0 );

			var scrollHeight = this.scrollHeight;
			var textareaHeight = scrollHeight;

			jQuery(this).css( 'height', textareaHeight + 'px' );
		});
	},

	inlineYoutube: function () {
		jQuery( document ).on( "click", ".youtube__player" , function() {
			var video_id = jQuery( this ).find( '.youtube-inline-player' ).data("youtube");
			jQuery( this ).addClass('played');
			jQuery( this ).html('<iframe src="https://www.youtube.com/embed/' + video_id + '?autoplay=1&mute=0&rel=0&" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="parent-background"></iframe>');
		});
	},

	lazyVideo: function () {
		jQuery('source[data-src]').each(function(){
			var sourceFile = jQuery( this ).attr('data-src');
			jQuery(this).attr('src', sourceFile);

			var videoElement = jQuery(this).parent().get(0);
			if (!videoElement.playing) {
				videoElement.load();
				videoElement.play();
			}

			jQuery(this).removeAttr('data-src', sourceFile);
		});
    },

	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},
	smoothScroll: {
		selector: 'a[href*="#"]:not([href="#"])',
		init: function () {
			var self = this;
			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 1000,
				offset: function (anchor, toggle) {
					var headerOffset = jQuery( '.header.header--p-fixed .header__row').outerHeight();

					if( jQuery( anchor ).offset().top < jQuery( window ).scrollTop() + headerOffset ) {
						headerOffset = jQuery( '.header.header--p-fixed' ).css( '--header-height' )
						headerOffset = headerOffset.replace( 'px', '');
					}

					if( !headerOffset ) {
						headerOffset = 0;
					}
	
					return headerOffset;
				},
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},
	openSearch: function () {
		jQuery( document ).on( "click", ".js-openSearch" , function( event ) {
			event.preventDefault();
			
			jQuery(".js-search").fadeIn();
			jQuery(".js-search .container").addClass("active");
			jQuery(".js-search input[type=search]").focus();
        });
	},
	closeSearch: function () {
		jQuery( document ).on( "click", ".js-search" , function( event ) {

			if (!jQuery(event.target).closest(".js-search .container").length) {
				jQuery(".js-search").fadeOut();
				jQuery(".js-search .container").removeClass("active");
			}
        });

		jQuery(document).keyup(function(e) {
			if(jQuery(".js-search").length) {
				if (e.key === "Escape") {
					jQuery(".js-search").fadeOut();
					jQuery(".js-search .container").removeClass("active");
				}
			}
	   });
	},

	hideShowHeader: function () {
		var self = this;
		var currentScroll = self.windowPosition()['y'];
		var fixedHeader = currentScroll > 0;
		var scrollUp = "scroll-up";
		var scrollDown = "scroll-down";
		var body = document.querySelector('body');

		if ( fixedHeader && jQuery( '.header' ).hasClass('header--p-fixed') ) {
			body.classList.add('fixed-header');

			if( currentScroll >= 100 ) {
				if (currentScroll > self.globals.lastScroll && !body.classList.contains(scrollDown)) {
					// down
					body.classList.remove(scrollUp);
					body.classList.add(scrollDown);

					var smallMenuHeight = 0;
					if( jQuery( '.header__row--small' ).length ) {
						var smallMenuHeight = jQuery( '.header__row--small' ).outerHeight();
					}

					var messageHeight = 0;
					if( jQuery( '.header-message' ).next( 'div' ).length ) {
						var messageHeight = jQuery( '.header-message' ).outerHeight();
					}
					else {
						jQuery( '.header-message' ).addClass('hide');
					}

					var hideOffset = smallMenuHeight + messageHeight;

					jQuery( '.header' ).css( 'transform', 'translateY(-'+ hideOffset +'px) ');
					jQuery( '.header' ).css( '--hidden-offset', hideOffset + 'px');

				} else if (currentScroll < self.globals.lastScroll && body.classList.contains(scrollDown)) {
					// up
					body.classList.remove(scrollDown);
					body.classList.add(scrollUp);
					jQuery( '.header' ).css( 'transform', 'translateY(0) ');
					jQuery( '.header' ).css( '--hidden-offset', 0);
					jQuery( '.header-message' ).removeClass( 'hide' );
				}
			} else {
				body.classList.remove(scrollUp);
				body.classList.remove(scrollDown);
				jQuery( '.header' ).css( 'transform', 'translateY(0) ');
				jQuery( '.header' ).css( '--hidden-offset', 0);
				jQuery( '.header-message' ).removeClass( 'hide' );
			}

			self.globals.lastScroll = currentScroll;
		} else {
			document.querySelector('body').classList.remove('fixed-header');
		}
	},

	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},
	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},
	onresize() {
		var self = this;
		self.offsetHeader();

		self.hideShowHeader();
	},
	onscroll(position, previusPosition) {
		var self = this;
		var currentScroll = self.windowPosition()['y'];

		if(  currentScroll >= 100 ) {
			jQuery( '.scroll-top-button' ).addClass( 'active' );
		} else {
			jQuery( '.scroll-top-button' ).removeClass( 'active' );
		}

		animateBlocks.init();

		self.hideShowHeader();	
	},
};

jQuery(document).ready(function ($) {
	theme.init();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();
});

window.addEventListener('resize', function (e) {
	theme.onresize();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
}; 